module.exports = __webpack_public_path__ + "img/demo13.c4fa4f45.jpg";